import { SYMBOL_COUNT } from '@/pages/dsst/dsstConfig';

interface SymbolProps {
  symbolId: number;
  setIndex?: number;
  className?: string;
}

function renderSet0(id: number, className: string) {
  const c = `inline-block shrink-0 ${className}`;
  switch (id) {
    case 0:
      return (
        <svg viewBox="0 0 100 100" className={c} fill="currentColor">
          <path d="M50 0 L58 42 L100 50 L58 58 L50 100 L42 58 L0 50 L42 42 Z" />
        </svg>
      );
    case 1:
      return (
        <svg viewBox="0 0 100 100" className={c} fill="currentColor">
          <path d="M50 0 L100 60 L100 100 L0 100 L0 60 Z" />
        </svg>
      );
    case 2:
      return (
        <svg viewBox="0 0 100 100" className={c} fill="currentColor">
          <path d="M20 0 L80 0 L50 40 L80 100 L20 100 L50 60 Z" />
        </svg>
      );
    case 3:
      return (
        <svg viewBox="0 0 100 100" className={c} fill="currentColor">
          <path d="M0 100 L0 66 L33 66 L33 33 L66 33 L66 0 L100 0 L100 100 Z" />
        </svg>
      );
    case 4:
      return (
        <svg viewBox="0 0 100 100" className={c} fill="currentColor">
          <path d="M50 0 L100 25 L100 75 L50 100 L0 75 L0 25 Z" />
        </svg>
      );
    case 5:
      return (
        <svg viewBox="0 0 100 100" className={c} fill="currentColor">
          <path d="M50 50 C50 15, 80 15, 80 40 C80 65, 50 65, 50 50 Z" />
          <path d="M50 50 C85 50, 85 80, 60 80 C35 80, 35 50, 50 50 Z" />
          <path d="M50 50 C50 85, 20 85, 20 60 C20 35, 50 35, 50 50 Z" />
          <path d="M50 50 C15 50, 15 20, 40 20 C65 20, 65 50, 50 50 Z" />
        </svg>
      );
    default:
      return null;
  }
}

function renderSet1(id: number, className: string) {
  const c = `inline-block shrink-0 ${className}`;
  switch (id) {
    case 0:
      return (
        <svg viewBox="0 0 100 100" className={c} fill="currentColor">
          <path
            d="M50 5 A45 45 0 1 0 50 95 A45 45 0 1 0 50 5 Z M50 30 A20 20 0 1 0 50 70 A20 20 0 1 0 50 30 Z"
            fillRule="evenodd"
          />
        </svg>
      );
    case 1:
      return (
        <svg viewBox="0 0 100 100" className={c} fill="currentColor">
          <path d="M50 0 L100 40 L60 40 L60 60 L100 60 L50 100 L0 60 L40 60 L40 40 L0 40 Z" />
        </svg>
      );
    case 2:
      return (
        <svg viewBox="0 0 100 100" className={c} fill="currentColor">
          <path d="M0 0 L100 0 L50 35 L100 100 L0 100 L50 65 Z" />
        </svg>
      );
    case 3:
      return (
        <svg viewBox="0 0 100 100" className={c} fill="currentColor">
          <path d="M0 100 L0 75 L25 75 L25 50 L50 50 L50 25 L75 25 L75 0 L100 0 L100 100 Z" />
        </svg>
      );
    case 4:
      return (
        <svg viewBox="0 0 100 100" className={c} fill="currentColor">
          <path d="M0 100 L0 55 L20 25 L40 55 L50 15 L60 55 L80 25 L100 55 L100 100 Z" />
        </svg>
      );
    case 5:
      return (
        <svg viewBox="0 0 100 100" className={c} fill="currentColor">
          <path d="M30 0 L70 0 L70 50 C100 50, 100 100, 70 100 L30 100 C0 100, 0 50, 30 50 Z" />
        </svg>
      );
    default:
      return null;
  }
}

function renderSet2(id: number, className: string) {
  const c = `inline-block shrink-0 ${className}`;
  switch (id) {
    case 0:
      return (
        <svg viewBox="0 0 100 100" className={c} fill="currentColor">
          <path d="M50 0 L58 42 L100 50 L58 58 L50 100 L42 58 L0 50 L42 42 Z" />
        </svg>
      );
    case 1:
      return (
        <svg viewBox="0 0 100 100" className={c} fill="currentColor">
          <path d="M50 0 L100 60 L100 100 L0 100 L0 60 Z" />
        </svg>
      );
    case 2:
      return (
        <svg viewBox="0 0 100 100" className={c} fill="currentColor">
          <path d="M20 0 L80 0 L50 40 L80 100 L20 100 L50 60 Z" />
        </svg>
      );
    case 3:
      return (
        <svg viewBox="0 0 100 100" className={c} fill="currentColor">
          <path d="M0 100 L0 66 L33 66 L33 33 L66 33 L66 0 L100 0 L100 100 Z" />
        </svg>
      );
    case 4:
      return (
        <svg viewBox="0 0 100 100" className={c} fill="currentColor">
          <path d="M50 0 L100 25 L100 75 L50 100 L0 75 L0 25 Z" />
        </svg>
      );
    case 5:
      return (
        <svg viewBox="0 0 100 100" className={c} fill="currentColor">
          <circle cx="50" cy="50" r="14" />
          <circle cx="50" cy="18" r="12" />
          <circle cx="50" cy="82" r="12" />
          <circle cx="18" cy="50" r="12" />
          <circle cx="82" cy="50" r="12" />
        </svg>
      );
    default:
      return null;
  }
}

export default function Symbol({ symbolId, setIndex = 0, className = '' }: SymbolProps) {
  const safeId = symbolId % SYMBOL_COUNT;
  const safeSet = setIndex % 3;

  if (safeSet === 0) return renderSet0(safeId, className);
  if (safeSet === 1) return renderSet1(safeId, className);
  return renderSet2(safeId, className);
}